<template>
    <b-card no-body>
        <v-table name="MyShiftsTable" :items-provider="itemsProvider" :fields="fields" :buttons="buttons" pagination="server" :settings="true" :search="true" :loading="loading"> </v-table>

        <!-- Fotoğraf Detay Modal -->
        <b-modal v-model="photoModal.show" :title="photoModal.title" size="lg" ok-only ok-title="Kapat">
            <div v-if="photoModal.loading" class="text-center py-3">
                <b-spinner variant="primary" />
            </div>
            <div v-else-if="photoModal.photos.length === 0" class="text-center text-muted py-3">
                Bu vardiyaya ait fotoğraf bulunamadı.
            </div>
            <div v-else>
                <div v-if="photoModal.selectedPhoto" class="mb-2 text-center">
                    <div class="d-flex justify-content-between align-items-center mb-1">
                        <b-button variant="outline-secondary" size="sm" @click="photoModal.selectedPhoto = null">
                            <feather-icon icon="ArrowLeftIcon" class="mr-25" /> Geri
                        </b-button>
                        <a :href="getFileUrl(photoModal.selectedPhoto.FilePath)" target="_blank" class="btn btn-sm btn-outline-primary">
                            <feather-icon icon="ExternalLinkIcon" class="mr-25" /> Yeni Sekmede Aç
                        </a>
                    </div>
                    <img :src="getFileUrl(photoModal.selectedPhoto.FilePath)" :alt="photoModal.selectedPhoto.FileName" style="max-width:100%;max-height:70vh;border-radius:8px;" />
                </div>
                <div v-else>
                    <div v-for="group in groupedPhotos" :key="group.type" class="mb-2">
                        <h5 class="text-primary mb-1">{{ group.type === 'Start' ? 'Vardiya Başlangıç Fotoğrafları' : 'Vardiya Bitiş Fotoğrafları' }}</h5>
                        <div v-for="storageGroup in group.storages" :key="storageGroup.storageName" class="mb-1 border rounded p-1">
                            <h6 class="mb-75"><feather-icon icon="DatabaseIcon" size="14" class="mr-25" />{{ storageGroup.storageName }}</h6>
                            <div v-for="pumpGroup in storageGroup.pumps" :key="pumpGroup.pumpId" class="mb-75 ml-1">
                                <small class="font-weight-bold d-block mb-25">{{ pumpGroup.pumpName }} <span v-if="pumpGroup.meterType" class="text-muted font-weight-normal">({{ pumpGroup.meterType }})</span></small>
                                <div class="d-flex flex-wrap" style="gap:0.5rem;">
                                    <img v-for="photo in pumpGroup.photos" :key="photo.Id" :src="getFileUrl(photo.FilePath)" :alt="photo.FileName" style="width:100px;height:80px;object-fit:cover;border-radius:6px;border:1px solid #ebe9f1;cursor:pointer;" @click="photoModal.selectedPhoto = photo" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </b-card>
</template>

<script>
import { BCard, BButton, BModal, BSpinner } from "bootstrap-vue";
import FuelStorageApi from "@/api/fuel-storage";
import Utilities from "@/utilities/system/index";

export default {
    name: "MyShifts",
    components: {
        BCard,
        BButton,
        BModal,
        BSpinner,
    },
    data() {
        return {
            loading: false,
            fields: [
                {
                    key: "ShiftStartValue",
                    name: "Vardiya Başlangıç",
                    sortable: true,
                    tdClass: "w-30",
                },
                {
                    key: "ShiftEndValue",
                    name: "Vardiya Bitiş",
                    sortable: true,
                    tdClass: "w-30",
                },
                {
                    key: "Time",
                    name: "Toplam Süre",
                    sortable: false,
                    tdClass: "w-20",
                },
            ],
            buttons: [
                {
                    text: "Fotoğraflar",
                    icon: "CameraIcon",
                    variant: "info",
                    action: (item) => this.showPhotos(item),
                },
            ],
            photoModal: {
                show: false,
                title: "Vardiya Fotoğraflarım",
                loading: false,
                photos: [],
                selectedPhoto: null,
            },
        };
    },
    computed: {
        groupedPhotos() {
            const typeGroups = {};
            this.photoModal.photos.forEach((photo) => {
                const type = photo.PhotoType || "Start";
                if (!typeGroups[type]) typeGroups[type] = {};

                const storageName = photo.FuelStorageName || "Genel";
                if (!typeGroups[type][storageName]) typeGroups[type][storageName] = {};

                const pumpKey = photo.PumpId || "general";
                if (!typeGroups[type][storageName][pumpKey]) {
                    typeGroups[type][storageName][pumpKey] = {
                        pumpId: photo.PumpId,
                        pumpName: photo.PumpName || "Genel",
                        meterType: photo.MeterType || "",
                        photos: [],
                    };
                }
                typeGroups[type][storageName][pumpKey].photos.push(photo);
            });

            return Object.keys(typeGroups).map((type) => ({
                type,
                storages: Object.keys(typeGroups[type]).map((storageName) => ({
                    storageName,
                    pumps: Object.values(typeGroups[type][storageName]),
                })),
            }));
        },
    },
    methods: {
        getFileUrl(path) {
            if (!path) return "";
            if (path.startsWith("http")) return path;
            let baseUrl = Utilities.BaseURL.URL;
            if (!baseUrl || baseUrl === "undefined" || baseUrl === "") {
                baseUrl = "https://localhost:7287";
            }
            baseUrl = baseUrl.replace(/\/api\/?$/, "");
            const cleanPath = path.replace(/^\//, "");
            return `${baseUrl}/${cleanPath}`;
        },
        async itemsProvider(params) {
            this.loading = true;
            try {
                const response = await FuelStorageApi.FuelStorageShift.TableCurrentUser(params);
                return {
                    data: response.data,
                };
            } catch (error) {
                console.error("Vardiya bilgileri alınamadı:", error);
                return { data: { Data: [], TotalCount: 0 } };
            } finally {
                this.loading = false;
            }
        },
        async showPhotos(item) {
            this.photoModal.title = "Vardiya Fotoğraflarım";
            this.photoModal.photos = [];
            this.photoModal.selectedPhoto = null;
            this.photoModal.show = true;
            this.photoModal.loading = true;
            try {
                const res = await FuelStorageApi.FuelStorageShift.GetPhotos(item.Id);
                if (res.data.Success) {
                    this.photoModal.photos = res.data.Data || [];
                }
            } catch (error) {
                console.error("Fotoğraflar yüklenemedi", error);
            } finally {
                this.photoModal.loading = false;
            }
        },
    },
};
</script>
